import { render } from "./Painel.vue?vue&type=template&id=dc957f16&scoped=true"
import script from "./Painel.vue?vue&type=script&lang=js"
export * from "./Painel.vue?vue&type=script&lang=js"

import "./Painel.vue?vue&type=style&index=0&id=dc957f16&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dc957f16"]])

export default __exports__